<template>
    <div class="">
    <Heading :isLogin="isLogin"></Heading>
    <div class="wrap">
        <div class="content">
            <div class="top-ad" v-html="ad.index_top_not_login"></div>
            <div class="charts-wrap" v-bind:class="{pullleft: showMNav}">
                <h1>新能源车产销量查询<span @click="showMNav = !showMNav"></span></h1>
                <ul class="charts-nav">
                    <li v-for="(tab, index) in chartsTab" :class="{on:chartsOn===index}" @click="toggleTab(index ,tab.type)">
                        <a href="javascript:;">{{tab.text}}</a>
                    </li>
                </ul>
                <div class="charts-content" v-show="showCharts.industry">
                    <div class="charts-select">
                        <select class="power_type" @change="changeIndustrySelect($event)">
                            <option value="ev" selected="selected">纯电动</option>
                            <option value="phev">插电式混合电动</option>
                        </select>
                        <select class="usage" @change="changeIndustrySelect($event)">
                            <option value="passenger_car" selected="selected">乘用车</option>
                            <option value="commercial_car">商务车</option>
                        </select>
                        <select class="year" @change="changeIndustrySelect($event)">
                            <option value="2009">2009</option>
                            <option value="2010">2010</option>
                            <option value="2011">2011</option>
                            <option value="2012">2012</option>
                            <option value="2013">2013</option>
                            <option value="2014">2014</option>
                            <option value="2015">2015</option>
                            <option value="2016" selected="selected">2016</option>
                        </select>
                    </div>
                    <div class="charts-data">
                        <div class="production-data">
                            <div class="total">
                                <span class="data-num">{{industryProduction.total | toThousands}}</span>
                                <span class="data-tag">总产量</span>
                            </div>
                            <div class="average">
                                <span class="data-num">{{industryProduction.average | toThousands}}</span>
                                <span class="data-tag">月均产量</span>
                            </div>
                            <div class="max">
                                <span class="data-num">{{industryProduction.max | toThousands}}</span>
                                <span class="data-tag">最高月产</span>
                            </div>
                        </div>
                        <div class="sales-data">
                            <div class="total">
                                <span class="data-num">{{industrySales.total | toThousands}}</span>
                                <span class="data-tag">总销量</span>
                            </div>
                            <div class="average">
                                <span class="data-num">{{industrySales.average | toThousands}}</span>
                                <span class="data-tag">月均销量</span>
                            </div>
                            <div class="max">
                                <span class="data-num">{{industrySales.max | toThousands}}</span>
                                <span class="data-tag">最高月销</span>
                            </div>
                        </div>
                    </div>
                    <div class="charts" id="industry-charts">

                    </div>
                </div>
                <div class="charts-content" v-show="showCharts.enterprise">
                    <div class="charts-select">
                        <select class="company" @change="changeEnterpriseSelect1($event)">
                            <option v-for="item in brand" :value="item.brand_id">{{item.name}}</option>
                        </select>
                        <select class="car_name" @change="changeEnterpriseSelect2($event)">
                            <option v-for="item in brandOption" :value="item.id">{{item.name}}</option>
                        </select>
                        <select class="year" @change="changeEnterpriseSelect3($event)">
                            <option value="2009">2009</option>
                            <option value="2010">2010</option>
                            <option value="2011">2011</option>
                            <option value="2012">2012</option>
                            <option value="2013">2013</option>
                            <option value="2014">2014</option>
                            <option value="2015">2015</option>
                            <option value="2016" selected="selected">2016</option>
                        </select>
                    </div>
                    <div class="charts-data">
                        <div class="production-data">
                            <div class="total">
                                <span class="data-num">{{enterpriseProduction.total | toThousands}}</span>
                                <span class="data-tag">总产量</span>
                            </div>
                            <div class="average">
                                <span class="data-num">{{enterpriseProduction.average | toThousands}}</span>
                                <span class="data-tag">月均产量</span>
                            </div>
                            <div class="max">
                                <span class="data-num">{{enterpriseProduction.max | toThousands}}</span>
                                <span class="data-tag">最高月产</span>
                            </div>
                        </div>
                        <div class="sales-data">
                            <div class="total">
                                <span class="data-num">{{enterpriseSales.total | toThousands}}</span>
                                <span class="data-tag">总销量</span>
                            </div>
                            <div class="average">
                                <span class="data-num">{{enterpriseSales.average | toThousands}}</span>
                                <span class="data-tag">月均销量</span>
                            </div>
                            <div class="max">
                                <span class="data-num">{{enterpriseSales.max | toThousands}}</span>
                                <span class="data-tag">最高月销</span>
                            </div>
                        </div>
                    </div>
                    <div class="charts" id="enterprise-charts">

                    </div>
                </div>
                <div class="charts-content" v-show="showCharts.proportion">
                    <div class="charts-select">
                        <select class="power_type" @change="changeProportionSelect($event)">
                            <option value="ev" selected="selected">纯电动</option>
                            <option value="phev">插电式混合电动</option>
                        </select>
                        <select class="usage" @change="changeProportionSelect($event)">
                            <option value="passenger_car" selected="selected">乘用车</option>
                            <option value="commercial_car">商务车</option>
                        </select>
                        <select class="year" @change="changeProportionSelect($event)">
                            <option value="2009">2009</option>
                            <option value="2010">2010</option>
                            <option value="2011">2011</option>
                            <option value="2012">2012</option>
                            <option value="2013">2013</option>
                            <option value="2014">2014</option>
                            <option value="2015">2015</option>
                            <option value="2016" selected="selected">2016</option>
                        </select>
                    </div>
                    <div class="charts" id="proportion-charts">

                    </div>
                    <ul class="variation">
                        <li v-for="item in proportionData.variation">
                            {{item}}
                            <i v-if="item.slice(0,-1)-0>0" class="up">↑</i>
                            <i v-if="item.slice(0,-1)-0===0" class="equal">-</i>
                            <i v-if="item.slice(0,-1)-0<0" class="down">↓</i>
                        </li>
                    </ul>
                </div>
                <div class="reference-chart" v-if="isLogin">
                    <button @click="referenceTable()" class="btn btn-blue" type="button" name="button">{{copyMsg}}</button>
                </div>
            </div>
            <Mnav :showMNav="showMNav"></Mnav>
        </div>
        <Side :ad="ad"></Side>
    </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Side from './Side'
    import Heading from './Header'
    import Mnav from './Mnav'
    import axios from 'axios'
    import echarts from 'echarts'

    export default {
        components: {
            Side,
            Heading,
            Mnav
        },
        data() {
            return {
                isLogin: false,
                copyMsg: '引用图表',
                socalLoginType: '',
                ad: {},
                brand: {},
                brandOption: {},
                industryProduction:  {},
                industrySales:  {},
                enterpriseProduction: {},
                enterpriseSales: {},
                proportionData: {},
                industry: {
                    power_type: 'ev',
                    usage: 'passenger_car',
                    year: 2016
                },
                enterprise: {
                    brand_id: 1,
                    car_id: 1,
                    year: 2016
                },
                proportion: {
                    power_type: 'ev',
                    usage: 'passenger_car',
                    year: 2016
                },
                chartsOn: 0,
                chartsTab: [
                    {
                        type: 'industry',
                        text: '行业数据统计'
                    },
                    {
                        type: 'enterprise',
                        text: '企业数据统计'
                    },
                    {
                        type: 'proportion',
                        text: '国内品牌市场份额 Top10'
                    }
                ],
                showCharts: {
                    industry: true,
                    enterprise: false,
                    proportion: false,
                },
                showMNav: false
            }
        },
        filters: {
            toThousands: function(num) {
                if(num === 0) {
                    return '-';
                }
                var num = (Math.round(num) || 0).toString(), result = '';
                while (num.length > 3) {
                    result = ',' + num.slice(-3) + result;
                    num = num.slice(0, num.length - 3);
                }
                if (num) { result = num + result; }
                return result;
            }
        },
        mounted() {
            Vue.auth.listen('login', () => {
                this.isLogin = true;
            })
            this.$nextTick(function () {
                this.getAd();
                this.getBrand();
                this.getBrandOption(1);
                this.getIndustryData();
                // this.getEnterpriseData();
                // this.getProportionData();
                this.changeMobileText();
            });
        },
        created () {
            this.listenParams();
        },
        methods: {
            showMobileNav() {

            },
            listenParams () {
                var reg = new RegExp('[/?&]' + 'service' + '=([^$&]+)');
                let matchs = window.location.search.match(reg);

                if (matchs && matchs[1]) {
                    this.startSocialLogin(unescape(matchs[1]));
                } else {
                    this.checkLogin();
                }
            },
            checkLogin () {
                var t = Vue.auth.getToken();
                if (t) {
                    this.isLogin = true;
                }
            },
            startSocialLogin (key) {
                axios.get('/api/socialite/auth/' + key + '/callback')
                .then((res) => {
                    if (res.data.code === 0) {
                        Vue.auth.dispatch('login');
                        Vue.auth.setToken(res.data.data);
                    }
                })
                .catch(() => {
                    // Vue.auth.dispatch('login');
                });
            },
            referenceTable () {
                var activeTab = this.chartsTab[this.chartsOn],
                    selectedFilter = this[activeTab.type];

                var queryString = '?type=';
                    queryString += activeTab.type;

                if (activeTab.type === 'enterprise') {
                    queryString += '&brand_id=' + selectedFilter.brand_id;
                    queryString += '&car_id=' + selectedFilter.car_id;
                    queryString += '&year=' + selectedFilter.year;
                } else {
                    queryString += '&power_type=';
                    queryString += selectedFilter.power_type;
                    queryString += '&usage=';
                    queryString +=  selectedFilter.usage;
                    queryString +=  '&year=';
                    queryString +=  selectedFilter.year;
                }

                var iframeString = '<iframe width="100%" height="350px" src="';
                    iframeString += 'http://dev.tool.evhui.com/api/car/reference-charts' + queryString;
                    iframeString += '" frameborder="0" allowfullscreen=""></iframe>';

                    this.copyToClipBoard(iframeString);
            },
            copyToClipBoard (text) {
                var textArea = document.createElement("textarea");
                textArea.style.position = 'fixed';
                textArea.style.top = 0;
                textArea.style.left = 0;
                textArea.style.width = '2em';
                textArea.style.height = '2em';

                textArea.style.padding = 0;

                textArea.style.border = 'none';
                textArea.style.outline = 'none';
                textArea.style.boxShadow = 'none';

                textArea.style.background = 'transparent';


                textArea.value = text;

                document.body.appendChild(textArea);

                textArea.select();
                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    this.copyMsg = '引用图表成功,请粘贴';
                } catch (err) {
                    this.copyMsg = '引用图表成功';
                }
                document.body.removeChild(textArea);
                window.setTimeout(() => {
                    this.copyMsg = '引用图表';
                }, 2000)
            },
            toggleTab(i, v) {
                this.chartsOn = i;
                for(var key in this.showCharts) {
                    this.showCharts[key] = false;
                }
                this.showCharts[v] = true;
                if(this.chartsOn === 1) {
                    this.getEnterpriseData();
                }else if(this.chartsOn === 2) {
                    this.getProportionData();
                }
            },
            changeIndustrySelect(event) {
                var val = event.target.value;
                var type = event.target.classList.value;
                this.industry[type] = val;
                this.getIndustryData();
            },
            changeEnterpriseSelect1(event) {
                var brand_id = event.target.value;
                this.enterprise['brand_id'] = brand_id;
                this.brandOption = {};
                this.getBrandOption(brand_id);
            },
            changeEnterpriseSelect2(event) {
                var car_id = event.target.value;
                this.enterprise['car_id'] = car_id;
                this.getEnterpriseData();
            },
            changeEnterpriseSelect3(event) {
                var year = event.target.value;
                this.enterprise['year'] = year;
                this.getEnterpriseData();
            },
            changeProportionSelect(event) {
                var val = event.target.value;
                var type = event.target.classList.value;
                this.proportion[type] = val;
                this.getProportionData();
            },
            getAd() {
                let that = this;
                axios.get('/api/blog/advert').then((res) => {
                    that.ad = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            getBrand() {
                let that = this;
                axios.get('/api/car/brand').then((res) => {
                    that.brand = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            getBrandOption(id) {
                let that = this;
                axios.get('/api/car/options/brand/'+id).then((res) => {
                    that.brandOption = res.data.data;
                    this.enterprise.car_id = res.data.data[0].id;
                    this.getEnterpriseData();
                }).catch((err) => {
                    console.log(err);
                });
            },
            getIndustryData() {
                let that = this;
                axios.get('/api/car/industry',{
                    params: {
                        power_type: that.industry.power_type,
                        usage: that.industry.usage,
                        year: that.industry.year
                    }
                }).then((res) => {
                    console.log(res.data.data);
                    that.industryProduction = res.data.data.production;
                    that.industrySales = res.data.data.sales;
                    that.showIndustryEcharts();
                }).catch((err) => {
                    console.log(err);
                });
            },
            getEnterpriseData() {
                let that = this;
                axios.get('/api/car/enterprise',{
                    params: {
                        brand_id: that.enterprise.brand_id,
                        car_id: that.enterprise.car_id,
                        year: that.enterprise.year
                    }
                }).then((res) => {
                    that.enterpriseProduction = res.data.data.production;
                    that.enterpriseSales = res.data.data.sales;
                    that.showEnterpriseEcharts();
                }).catch((err) => {
                    console.log(err);
                });
            },
            getProportionData() {
                let that = this;
                axios.get('/api/car/proportion',{
                    params: {
                        power_type: that.proportion.power_type,
                        usage: that.proportion.usage,
                        year: that.proportion.year
                    }
                }).then((res) => {
                    that.proportionData = res.data.data;
                    that.showProportionEcharts();
                }).catch((err) => {
                    console.log(err);
                });
            },
            showIndustryEcharts() {
                let that = this;
                var myChart = echarts.init(document.getElementById('industry-charts'));
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#fff',
                        borderColor: '#E5E5E5',
                        padding: [10, 20],
                        extraCssText: 'box-shadow: 0 1px 5px 0 rgba(0,0,0,0.10);',
                        textStyle: {
                            color: '#333',
                            fontSize: 13
                        },
                        formatter: function (params,ticket,callback) {
                            var bgColor = ['#62BBEE', '#F97C99']
                            var res = '';
                            for (var i = 0, l = params.length; i < l; i++) {
                                res += '<i style="display:inline-block;width:8px;height:8px;margin-right:6px;background-color:'+bgColor[i]+'"></i>' +
                                        params[i].seriesName +
                                        ' : ' +
                                        params[i].value +
                                        '<br>';
                            }
                            return res;
                        }
                    },
                    grid: {
                        left: '4%',
                        right: '4%',
                        bottom: '4%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            inside: true,
                            interval: function(index, value) {
                                // 展示1 3 6 9 12
                                var showIndexArr = [0, 2, 5, 8, 11];
                                if(showIndexArr.indexOf(index) !== -1) {
                                    return true;
                                }
                            },
                            textStyle: {
                                color: '#666',
                                align: 'center',
                                fontSize: 11
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisPointer: {
                            lineStyle: {
                                type: 'dashed',
                                width: 2,
                                color: '#fff'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        zlevel: 20,
                        data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            inside: true,
                            showMinLabel: false,
                            margin: 0,
                            textStyle: {
                                color: '#666',
                                align: 'left',
                                fontSize: 11
                            }
                        },
                        splitNumber: 3,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        zlevel: 20,
                        max: Math.max(that.industryProduction.max, that.industrySales.max)
                    },
                    series: [
                        {
                            name:'产量',
                            type:'line',
                            smooth: true,
                            areaStyle : {
                                normal : {
                                    color:'#dff2fc'
                                }
                            },
                            lineStyle : {
                                normal : {
                                    color:'#62BBEE',
                                    width: 4
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: '#62BBEE',
                                    borderWidth: 3
                                }
                            },
                            data: that.industryProduction.monthly
                        },
                        {
                            name:'销量',
                            type:'line',
                            smooth: true,
                            areaStyle : {
                                normal : {
                                    color:'#eadae5'
                                }
                            },
                            lineStyle : {
                                normal : {
                                    color:'#F97C99',
                                    width: 4
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: '#F97C99',
                                    borderWidth: 3
                                }
                            },
                            data: that.industrySales.monthly
                        }
                    ]
                });
            },
            showEnterpriseEcharts() {
                let that = this;
                var myChart = echarts.init(document.getElementById('enterprise-charts'));
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#fff',
                        borderColor: '#E5E5E5',
                        padding: [10, 20],
                        extraCssText: 'box-shadow: 0 1px 5px 0 rgba(0,0,0,0.10);',
                        textStyle: {
                            color: '#333',
                            fontSize: 13
                        },
                        formatter: function (params,ticket,callback) {
                            var bgColor = ['#62BBEE', '#F97C99']
                            var res = '';
                            for (var i = 0, l = params.length; i < l; i++) {
                                res += '<i style="display:inline-block;width:8px;height:8px;margin-right:6px;background-color:'+bgColor[i]+'"></i>' +
                                        params[i].seriesName +
                                        ' : ' +
                                        params[i].value +
                                        '<br>';
                            }
                            return res;
                        }
                    },
                    grid: {
                        left: '4%',
                        right: '4%',
                        bottom: '4%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            inside: true,
                            interval: function(index, value) {
                                // 展示1 3 6 9 12
                                var showIndexArr = [0, 2, 5, 8, 11];
                                if(showIndexArr.indexOf(index) !== -1) {
                                    return true;
                                }
                            },
                            textStyle: {
                                color: '#666',
                                align: 'center',
                                fontSize: 11
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisPointer: {
                            lineStyle: {
                                type: 'dashed',
                                width: 2,
                                color: '#fff'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        zlevel: 20,
                        data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            inside: true,
                            showMinLabel: false,
                            margin: 0,
                            textStyle: {
                                color: '#666',
                                align: 'left',
                                fontSize: 11
                            }
                        },
                        splitNumber: 3,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        zlevel: 20,
                        max: Math.max(that.enterpriseProduction.max, that.enterpriseSales.max)
                    },
                    series: [
                        {
                            name:'产量',
                            type:'line',
                            smooth: true,
                            areaStyle : {
                                normal : {
                                    color:'#dff2fc'
                                }
                            },
                            lineStyle : {
                                normal : {
                                    color:'#62BBEE',
                                    width: 4
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: '#62BBEE',
                                    borderWidth: 3
                                }
                            },
                            data: that.enterpriseProduction.monthly
                        },
                        {
                            name:'销量',
                            type:'line',
                            smooth: true,
                            areaStyle : {
                                normal : {
                                    color:'#eadae5'
                                }
                            },
                            lineStyle : {
                                normal : {
                                    color:'#F97C99',
                                    width: 4
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderColor: '#F97C99',
                                    borderWidth: 3
                                }
                            },
                            data: that.enterpriseSales.monthly
                        }
                    ]
                });
            },
            showProportionEcharts() {
                let that = this;
                var myChart = echarts.init(document.getElementById('proportion-charts'));
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#fff',
                        borderColor: '#E5E5E5',
                        padding: [10, 20],
                        extraCssText: 'box-shadow: 0 1px 5px 0 rgba(0,0,0,0.10);',
                        textStyle: {
                            fontSize: 16
                        },
                        formatter: function (params,ticket,callback) {
                            console.log(params);
                            var res = '';
                            for (var i = 0, l = params.length; i < l; i++) {
                                res += '<span style="color:#999">'+params[i].seriesName +
                                    '</span> : ' +
                                    '<span style="color:#000">'+(params[i].value*100).toFixed(2)+'%' +
                                    '</span><br>';
                            }
                            return res;
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '25',
                        top: '25',
                        containLabel: true
                    },
                    xAxis: {
                        show: false,
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        axisLabel: {
                            textStyle: {
                                color: '#666',
                                fontSize: 11
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisPointer: {
                            lineStyle: {
                                type: 'dashed',
                                width: 0,
                                color: '#fff'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        type: 'category',
                        data: that.proportionData.name,
                    },
                    series: [
                        {
                            name: that.proportionData.year + '年',
                            type: 'bar',
                            data: that.proportionData.now,
                            itemStyle: {
                                normal: {
                                    color: '#b6a2de'
                                }
                            },
                            barWidth: 10
                        },
                        {
                            name: that.proportionData.year - 1 + '年',
                            type: 'bar',
                            data: that.proportionData.last,
                            itemStyle: {
                                normal: {
                                    color: '#d4c6f0'
                                }
                            },
                            barWidth: 10
                        }
                    ]
                });
            },
            changeMobileText() {
                console.log(window.innerWidth);
                var wiw = window.innerWidth;
                if(wiw < 415) {
                    this.chartsTab = [
                        {
                            type: 'industry',
                            text: '行业'
                        },
                        {
                            type: 'enterprise',
                            text: '企业'
                        },
                        {
                            type: 'proportion',
                            text: '国内份额'
                        }
                    ]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .wrap {
        width: 1030px;
        margin: 0 auto;
        padding-top: 100px;
        &:after {
            content: "";
            display: block;
            clear: both;
        }
    }
    .content {
        float: left;
        width: 760px;
        background-color: #fff;
        box-sizing: border-box;
        .top-ad {
            width: 700px;
            height: 90px;
            padding: 20px 30px 0 30px;
            margin-bottom: 30px;
        }
        h1 {
            padding: 0 30px;
            font-size: 36px;
            line-height: 1;
            color: #000;
        }
    }
    .greyblock {
        width: 100%;
        height: 20px;
        background-color: #f2f2f2;
    }
    .charts-wrap {
        .reference-chart {
            text-align: center;
            margin: 0 0 30px 0;
            .btn {
                height: 40px;
                text-align: center;
                border-radius: 2px;
                color: #fff;
                border: none;
                outline: 0;
                cursor: pointer;
                transition: all ease 0.3s;
            }
            .btn-blue {
                background-color: #0666B2;
                padding-right: 30px;
                padding-left: 30px;
                &:hover {
                    background-color: darken(#0666B2, 10%);
                }
            }
        }
        .charts-nav {
            margin-top: 40px;
            border-bottom: 1px solid #e5e5e5;
            &:after {
                content: "";
                display: block;
                clear: both;
            }
            li {
                float: left;
                height: 60px;
                padding: 0 32px;
                font-size: 16px;
                line-height: 60px;
                text-align: center;
                border-top: 2px solid #fff;
                border-left: 1px solid #fff;
                border-right: 1px solid #fff;
                &:first-child {
                    margin-left: 30px;
                }
                a {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    color: #333;
                }
            }
            .on {
                position: relative;
                border-left: 1px solid #e5e5e5;
                border-right: 1px solid #e5e5e5;
                border-top: 2px solid $maincolor;
                &:after {
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: -1px;
                    width: 100%;
                    height: 1px;
                    background-color: #fff;
                }
            }
        }
        .charts-content {
            position: relative;
            padding: 40px 30px 60px;
        }
        .charts {
            width: 700px;
            height: 300px;
        }
        #proportion-charts {
            width: 580px;
            height: 460px;
        }
    }
    .charts-select {
        select {
            height: 32px;
            margin-right: 28px;
            padding-left: 10px;
            padding-right: 31px;
            font-size: 16px;
            vertical-align: middle;
        }
    }
    .charts-data {
        display: flex;
        justify-content: space-between;
        width: 700px;
        height: 120px;
        margin-top: 24px;
        padding: 35px 0;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        &>div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 50%;
            &:first-child {
                border-right: 1px solid #e5e5e5;
            }
            div {
                display: flex;
                flex-direction: column;
            }
        }
        .data-tag {
            font-size: 16px;
            color: #666;
        }
        .production-data {
            .data-num {
                color: #62bbee;
            }
        }
        .sales-data {
            .data-num {
                color: #f97c99;
            }
        }
        .data-num {
            margin-bottom: 10px;
            font-size: 20px;
        }
        .total .data-num {
            font-size: 26px;
        }
    }
    .variation {
        position: absolute;
        top: 97px;
        right: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 100px;
        height: 390px;
        li {
            padding-right: 20px;
            text-align: right;
            font-size: 14px;
            line-height: 14px;
            color: $maincolor;
            i {
                display: inline-block;
                font-size: 14px;
                line-height: 14px;
            }
            .up {
                color: #f97c99;
            }
            .equal {
                color: #999;
            }
            .up {
                color: #79ce5f;
            }
        }
    }
    @media (min-width: 415px) {
        select {
            width: 200px;
            height: 32px;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            border: 1px solid #999;
            border-radius: 0;
            background: url("../assets/images/arrow.png") no-repeat scroll right center transparent;
        }
    }
    @media (max-width: 414px) {
        * {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
        .wrap {
            width: 100%;
            padding-top: 0;
            .content {
                overflow: hidden;
            }
        }
        .top-ad {
            display: none;
        }
        .charts-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: -webkit-transform 0.33s cubic-bezier(0.29, 0.05, 0.14, 0.87);
            h1 {
                position: relative;
                width: 100%;
                height: 60px;
                padding: 0;
                text-align: center;
                background-color: $maincolor;
                font-size: 20px;
                color: #D1DFE9;
                line-height: 60px;
                text-align: center;
                span {
                    position: absolute;
                    top: 17px;
                    right: 17px;
                    width: 26px;
                    height: 26px;
                    background-image: url("../../static/img/toggle.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                }
            }
        }
        .pullleft {
            transform: translateX(-270px);
        }
        .charts-wrap .charts-nav {
            width: 300px;
            margin: 0 auto;
            border-bottom: none;
        }
        .charts-wrap .charts-nav li:first-child {
            margin-left: 0;
        }
        .charts-wrap .charts-nav li {
            width: 100px;
            height: 45px;
            padding: 0;
            border: none;
        }
        .charts-wrap .charts-nav li a {
            padding: 20px 0 7px;
            line-height: 1;
            box-sizing: border-box;
        }
        .charts-wrap .charts-nav .on {
            a {
                color: $maincolor;
            }
            border-left: none;
            border-right: none;
            border-top: none;
            border-bottom: 2px solid $maincolor;
        }
        .charts-wrap .charts-content {
            padding: 0;
        }
        .charts-select {
            display: flex;
            justify-content: space-between;
            padding: 20px 25px 0;
            select {
                width: 100px;
                height: 30px;
                margin-right: 0;
                padding: 0;
            }
        }
        .charts-data {
            display: flex;
            flex-direction: column;
            width: 325px;
            height: 130px;
            margin: 16px auto 0;
            padding: 15px 20px;
            box-shadow: 0 1px 5px 0 rgba(0,0,0,0.10);
            & > div {
                align-items: flex-end;
                width: 100%;
                &:first-child {
                    border-right: none;
                }
            }
            .data-num {
                margin-bottom: 6px;
                font-size: 18px;
            }
            .total .data-num {
                font-size: 25px;
            }
            .data-tag {
                font-size: 11px;
                color: #999;
            }
        }
        #industry-charts,
        #enterprise-charts {
            width: 100vw;
            height: 42vh;
        }
        .charts-wrap #proportion-charts {
            width: 75vw;
            height: 68vh;
        }
        .variation {
            top: 75px;
            right: 0;
            width: 25vw;
            height: 57vh;
        }
    }
</style>



// WEBPACK FOOTER //
// Main.vue?23621fc8